import { Box } from "@mui/material";
import ListCreateTab from "components/ListCreateTab";
import React from "react";
import { ImUsers, ImUserPlus } from "react-icons/im";
import AccountsCreateForm from "pages/accounts/AccountsCreateForm";
import ProfileView from "pages/accounts/ProfileView";
import { createMachineAdminThunk } from "store/reducers/accounts";
import { useDispatch } from "react-redux";
function MachineAdminAccount() {
  const dispatch = useDispatch();
  const formCallback = (input) => {
    dispatch(createMachineAdminThunk(input));
  };
  return (
    <Box sx={{ display: "flex", flex: 1 }}>
      <ListCreateTab
        mod="Machine admin"
        viewIcon={<ImUsers />}
        createIcon={<ImUserPlus />}
        createChildren={
          <AccountsCreateForm mod="Machine admin" callback={formCallback} />
        }
        listChildren={<ProfileView mod="machineAdmin" />}
      />
    </Box>
  );
}

export default MachineAdminAccount;
